// Section-based access control (RBAC) — shared source of truth for the frontend.
// A "section" maps 1:1 to an app page/module. Keys MUST match the backend ALL_SECTIONS keys.
import { APP_BASE } from "@/lib/paths";

// Derive the section key that owns a given pathname (e.g. "/app/delivery-notes" -> "delivery-notes").
// "/app" (or "/app/") -> "dashboard". Returns null for non-app paths.
// Some pages share access with an existing section (alias -> canonical section key).
const SECTION_ALIASES = { subproducts: "stock", "raw-materials": "milk" };

export const sectionForPathname = (pathname = "") => {
  if (!pathname.startsWith(APP_BASE)) return null;
  const rel = pathname.slice(APP_BASE.length);
  if (!rel || rel === "/") return "dashboard";
  const key = rel.replace(/^\//, "").split("/")[0];
  return SECTION_ALIASES[key] || key;
};

// Sections that are configurable per role in the Permissions matrix, grouped for display.
// Labels reuse the existing nav.* i18n keys. "dashboard" is always-on (not listed);
// "users" & "permissions" are admin-only (not configurable).
export const PERMISSION_MATRIX = [
  {
    id: "general",
    labelKey: "perm.groupGeneral",
    items: [
      { key: "haccp", labelKey: "nav.haccp" },
      { key: "traceability", labelKey: "nav.traceability" },
    ],
  },
  {
    id: "reception",
    labelKey: "nav.modMilkReception",
    items: [
      { key: "milk", labelKey: "nav.milk" },
      { key: "suppliers", labelKey: "nav.suppliers" },
    ],
  },
  {
    id: "production",
    labelKey: "nav.modProduction",
    items: [
      { key: "productions", labelKey: "nav.productions" },
      { key: "products", labelKey: "nav.products" },
      { key: "planning", labelKey: "nav.planning" },
      { key: "calculator", labelKey: "nav.calculator" },
      { key: "templates", labelKey: "nav.templates" },
    ],
  },
  {
    id: "stock",
    labelKey: "nav.modStockOrders",
    items: [
      { key: "stock", labelKey: "nav.stock" },
      { key: "orders", labelKey: "nav.orders" },
      { key: "delivery-notes", labelKey: "nav.deliveryNotes" },
      { key: "clients", labelKey: "nav.clients" },
      { key: "price-lists", labelKey: "nav.priceLists" },
      { key: "product-packaging", labelKey: "nav.productPackaging" },
    ],
  },
  {
    id: "workforce",
    labelKey: "nav.modWorkforce",
    items: [
      { key: "operators", labelKey: "nav.operators" },
      { key: "time-clock", labelKey: "nav.timeClock" },
      { key: "tasks", labelKey: "nav.tasks" },
      { key: "complaints", labelKey: "nav.complaints" },
    ],
  },
  {
    id: "admin",
    labelKey: "nav.modSettingsAdmin",
    items: [
      { key: "settings", labelKey: "nav.settings" },
      { key: "activity", labelKey: "nav.activity" },
    ],
  },
];
